__turbopack_context__.v({
  "answer": "FAQItem-module-scss-module___GQxpa__answer",
  "faqItem": "FAQItem-module-scss-module___GQxpa__faqItem",
  "question": "FAQItem-module-scss-module___GQxpa__question",
});
